if(!window.__graoCartJs){window.__graoCartJs=1;
(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function money(c){return '$'+(c/100).toFixed(2);}
  function sbw(){if(!document.body.classList.contains('overflow-hidden')){document.documentElement.style.setProperty('--grao-sbw',(window.innerWidth-document.documentElement.clientWidth)+'px');}}
  function drawerEl(){return document.querySelector('cart-drawer');}
  /* Free-shipping bar: compute the fill width from the LIVE cart and force the copper colour,
     so the bar is correct regardless of any server-render/settings quirk. */
  function updateFsBar(){
    var fs=document.querySelector('.grao-fs[data-fs-threshold]');
    if(!fs)return;
    var bar=fs.querySelector('.grao-fs__bar');
    if(!bar)return;
    bar.style.background='#b8622e';
    var thr=parseInt(fs.getAttribute('data-fs-threshold'),10)||0;
    if(thr<=0)return;
    fetch(root+'cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var pct=Math.round(cart.total_price*100/thr);
        if(pct<4)pct=4;if(pct>100)pct=100;
        bar.style.width=pct+'%';
      }).catch(function(){});
  }
  var __fsTimer;
  function updateFsBarSoon(){clearTimeout(__fsTimer);__fsTimer=setTimeout(updateFsBar,150);}
  window.__graoDrawerRefresh=function(sections){
    try{
      if(sections&&sections['cart-drawer']){
        var doc=(new DOMParser()).parseFromString(sections['cart-drawer'],'text/html');
        var fresh=doc.querySelector('#CartDrawer');
        var cur=document.getElementById('CartDrawer');
        if(fresh&&cur){cur.innerHTML=fresh.innerHTML;}
        var d=drawerEl();
        if(d){
          d.classList.remove('is-empty');
          var ov=document.getElementById('CartDrawer-Overlay');
          if(ov)ov.addEventListener('click',d.close.bind(d));
        }
      }
      if(sections&&sections['cart-icon-bubble']){
        var el=document.getElementById('cart-icon-bubble');
        if(el){
          var doc2=(new DOMParser()).parseFromString(sections['cart-icon-bubble'],'text/html');
          var inner=doc2.querySelector('.shopify-section')||doc2.body;
          el.innerHTML=inner.innerHTML;
        }
      }
    }catch(err){}
  };
  window.__graoOpenDrawer=function(){var d=drawerEl();if(d&&d.open)d.open();};
  function addVariant(vid,cb){
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(vid),quantity:1,sections:'cart-drawer,cart-icon-bubble'})})
    .then(function(r){return r.json()})
    .then(function(dd){
      if(dd.status){if(cb)cb(false);return;}
      window.__graoDrawerRefresh(dd.sections||{});
      if(cb)cb(true);
    })
    .catch(function(){if(cb)cb(false);});
  }
  function recCard(d){
    var img=d.image?'<img src="'+d.image+'" alt="" loading="lazy">':'';
    var cmp=d.compare_at_price&&d.compare_at_price>d.price?' <s>'+money(d.compare_at_price)+'</s>':'';
    return '<script type="application/json" data-grao-rec-json>'+JSON.stringify(d)+'<\/script>'+
      '<div class="grao-rec__media"><a href="'+d.url+'">'+img+'</a>'+
      '<button type="button" class="grao-rec__qv" aria-label="Quick view"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10.5" cy="10.5" r="6.5" stroke="#1a1a1a" stroke-width="2"/><path d="M15.5 15.5L21 21" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/></svg></button></div>'+
      '<div class="grao-rec__info"><a class="grao-rec__title" href="'+d.url+'">'+d.title+'</a>'+
      '<div class="grao-rec__price"><span>'+money(d.price)+'</span>'+cmp+'</div></div>'+
      '<button type="button" class="grao-rec__add">Add</button>';
  }
  function enhanceRecs(){
    var wrap=document.querySelector('[data-grao-cart-recs]');
    if(!wrap||wrap.dataset.enhanced==='1')return;
    wrap.dataset.enhanced='1';
    var pids=[];
    try{pids=JSON.parse(wrap.getAttribute('data-cart-pids')||'[]');}catch(e){}
    var first=wrap.getAttribute('data-first-pid');
    if(!first)return;
    function apply(products){
      var picks=(products||[]).filter(function(p){return pids.indexOf(p.id)<0&&p.available!==false;}).slice(0,3);
      if(picks.length<1)return false;
      var list=wrap.querySelector('.grao-cart-recs__list');
      if(!list)return false;
      list.innerHTML='';
      picks.forEach(function(p){
        var d={id:p.id,title:p.title,url:p.url,image:p.featured_image||'',price:p.price,compare_at_price:p.compare_at_price||0,
          variants:(p.variants||[]).map(function(v){return {id:v.id,title:v.title,price:v.price,available:v.available};})};
        var el=document.createElement('div');
        el.className='grao-rec';
        el.innerHTML=recCard(d);
        list.appendChild(el);
      });
      return true;
    }
    fetch(root+'recommendations/products.json?product_id='+first+'&limit=8&intent=complementary')
    .then(function(r){return r.ok?r.json():null})
    .then(function(j){
      var prods=(j&&j.products)?j.products:[];
      if(apply(prods))return null;
      return fetch(root+'recommendations/products.json?product_id='+first+'&limit=8&intent=related')
        .then(function(r){return r.ok?r.json():null})
        .then(function(j2){if(j2&&j2.products)apply(j2.products);});
    }).catch(function(){});
  }
  var qv=document.getElementById('GraoQvCart');
  var qvState={variantId:null};
  function openQv(d){
    if(!qv)return;
    qv.querySelector('.grao-qv__media img').src=d.image||'';
    qv.querySelector('.grao-qv__title').textContent=d.title;
    qv.querySelector('.grao-qv__link').href=d.url;
    var opts=qv.querySelector('.grao-qv__opts');
    var optwrap=qv.querySelector('.grao-qv__optwrap');
    opts.innerHTML='';
    var first=null;
    d.variants.forEach(function(v){if(!first&&v.available)first=v;});
    if(d.variants.length>1){
      optwrap.style.display='';
      d.variants.forEach(function(v){
        var b=document.createElement('button');
        b.type='button';b.className='grao-qv__opt';b.textContent=v.title;
        b.setAttribute('data-variant-id',v.id);b.setAttribute('data-price',v.price);
        if(!v.available)b.disabled=true;
        if(first&&v.id===first.id)b.classList.add('is-selected');
        opts.appendChild(b);
      });
    }else{optwrap.style.display='none';}
    qvState.variantId=first?first.id:null;
    qv.querySelector('.grao-qv__price').textContent=money(first?first.price:d.price);
    var atc=qv.querySelector('.grao-qv__atc');
    atc.disabled=!qvState.variantId;
    atc.textContent='Add to Cart';
    qv.hidden=false;
  }
  function closeQv(){if(qv)qv.hidden=true;}
  document.addEventListener('click',function(e){
    if(e.target.closest('#GraoQvCart [data-qv-close]')){closeQv();return;}
    var opt=e.target.closest('#GraoQvCart .grao-qv__opt');
    if(opt&&!opt.disabled){
      qv.querySelectorAll('.grao-qv__opt').forEach(function(b){b.classList.remove('is-selected');});
      opt.classList.add('is-selected');
      qvState.variantId=opt.getAttribute('data-variant-id');
      qv.querySelector('.grao-qv__price').textContent=money(Number(opt.getAttribute('data-price')));
      return;
    }
    var atc=e.target.closest('#GraoQvCart .grao-qv__atc');
    if(atc&&qvState.variantId){
      atc.disabled=true;atc.textContent='Adding…';
      addVariant(qvState.variantId,function(ok){
        if(ok){atc.textContent='Added ✓';setTimeout(function(){closeQv();window.__graoOpenDrawer();},500);}
        else{atc.textContent='Add to Cart';atc.disabled=false;}
      });
      return;
    }
    var add=e.target.closest('.grao-rec__add');
    if(add){
      var card=add.closest('.grao-rec');
      var dataEl=card&&card.querySelector('[data-grao-rec-json]');
      if(dataEl){
        try{
          var d=JSON.parse(dataEl.textContent);
          var avail=d.variants.filter(function(v){return v.available;});
          if(d.variants.length>1){openQv(d);}
          else if(avail.length){
            add.disabled=true;add.textContent='…';
            addVariant(avail[0].id,function(ok){
              add.disabled=false;
              add.textContent=ok?'✓':'Add';
              if(ok){window.__graoOpenDrawer();setTimeout(function(){add.textContent='Add';},1200);}
            });
          }
        }catch(err){}
      }
      return;
    }
    var qvb=e.target.closest('.grao-rec__qv');
    if(qvb){
      var card2=qvb.closest('.grao-rec');
      var de=card2&&card2.querySelector('[data-grao-rec-json]');
      if(de){try{openQv(JSON.parse(de.textContent));}catch(err){}}
      return;
    }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&qv&&!qv.hidden)closeQv();});
  /* --- PDP thumbnail rail: pin its height (and top offset) to the real rendered main image,
         so the vertical strip lines up top and bottom regardless of image aspect/count.
         Measured at runtime, so it does not depend on flexbox stretch behaving. --- */
  function graoSyncThumbs(){
    var wrap=document.querySelector('.product--thumbnail .product__media-wrapper');
    if(!wrap)return;
    var gallery=wrap.querySelector('media-gallery');
    if(!gallery)return;
    var rail=gallery.querySelector('.thumbnail-slider');
    var active=gallery.querySelector('.product__media-item.is-active')||gallery.querySelector('.product__media-item');
    if(!rail||!active)return;
    if(window.innerWidth<750){
      if(rail.style.height!=='')rail.style.height='';
      if(rail.style.marginTop!=='')rail.style.marginTop='';
      return;
    }
    var gr=gallery.getBoundingClientRect();
    var ar=active.getBoundingClientRect();
    if(ar.height>0){
      // >1px dead-band so sub-pixel rect reads can't thrash the observer
      var hNum=Math.round(ar.height);
      var curH=parseInt(rail.style.height,10)||0;
      if(Math.abs(hNum-curH)>1)rail.style.height=hNum+'px';
      var mtNum=Math.round(ar.top-gr.top);if(mtNum<0)mtNum=0;
      var curMt=parseInt(rail.style.marginTop,10)||0;
      if(Math.abs(mtNum-curMt)>1)rail.style.marginTop=mtNum+'px';
    }
  }
  function graoInitThumbs(){
    var wrap=document.querySelector('.product--thumbnail .product__media-wrapper');
    if(!wrap)return;
    var gallery=wrap.querySelector('media-gallery');
    if(!gallery)return;
    graoSyncThumbs();
    if(window.ResizeObserver){
      var scheduled=false;
      var ro=new ResizeObserver(function(){
        if(scheduled)return;scheduled=true;
        window.requestAnimationFrame(function(){scheduled=false;graoSyncThumbs();});
      });
      ro.observe(gallery);
      var mv=gallery.querySelector('slider-component:not(.thumbnail-slider)');
      if(mv)ro.observe(mv);
    }
    window.addEventListener('resize',graoSyncThumbs);
    window.addEventListener('load',graoSyncThumbs);
    gallery.addEventListener('click',function(){setTimeout(graoSyncThumbs,80);});
    setTimeout(graoSyncThumbs,300);
    setTimeout(graoSyncThumbs,1200);
  }
  function watch(){
    sbw();
    window.addEventListener('resize',sbw);
    enhanceRecs();
    graoInitThumbs();
    updateFsBar();
    var d=drawerEl();
    if(d){new MutationObserver(function(){enhanceRecs();updateFsBarSoon();}).observe(d,{childList:true,subtree:true});}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watch);}else{watch();}
})();}
